import { UserTabComponentConfiguration } from './user-tab-configuration';

export class Component {
  public Id: string;
  public Title?: string;
  public Description?: string;
  public IconClass?: string;
  public IconUrl?: string;
  public UserTabConfigurations?: UserTabComponentConfiguration;
  public Configurations: { [key: string]: any; } = {};

  constructor(opt?: Partial<Component>) {
    Object.assign(this, opt);
  }
}
